<div class="button-wrapper d-flex udex-mb-20">
  <img *ngIf="getIconPath() as src" class="me-4 pb-2" alt="{{slmTransactionType.code}}" [src]="src">
  <div class="d-flex flex-column justify-content-around">
    <button class="execute-button" (click)="executeAction()">
      <span class="heading__medium--xxxxs">{{ ('ctaForm.buttonText.' + slmTransactionType.code | cxTranslate) }}</span>
    </button>
    <span class="body--s">
      {{ ('ctaForm.subText.' + slmTransactionType.code | cxTranslate) }}
    </span>
  </div>
</div>
